import { ContainerModule } from 'inversify';
import OrdersService from '../features/orders/data/service/OrdersService';
import OrdersRepository from '../features/orders/data/OrdersRepository';
import { OrdersServiceInterface } from '../features/orders/data/service/OrdersService.types';
import { OrdersRepositoryInterface } from '../features/orders/domain/OrdersRepositoryInterface';
import CreateMercadopagoOrderUseCase from 'src/features/orders/domain/useCases/CreateMercadopagoOrderUseCase';
import CreateBankTransferOrderUseCase from 'src/features/orders/domain/useCases/CreateBankTransferOrderUseCase';
import CreateEfektivaOrderUseCase from 'src/features/orders/domain/useCases/CreateEfektivaOrderUseCase';
import CreatePariTransferOrderUseCase from 'src/features/orders/domain/useCases/CreatePariTransferOrderUseCase';
import { ComplaintsServiceInterface } from 'src/features/complaints/data/service/ComplaintsService.types';
import ComplaintsService from 'src/features/complaints/data/service/ComplaintsService';
import { ComplaintsRepositoryInterface } from 'src/features/complaints/domain/ComplaintsRepositoryInterface';
import ComplaintsRepository from 'src/features/complaints/data/ComplaintsRepository';
import CreateMPWalletOrderUseCase from 'src/features/orders/domain/useCases/CreateMPWalletOrderUseCase';
import CreateClipOrderUseCase from 'src/features/orders/domain/useCases/CreateClipOrderUseCase';
import CreateOpenPayOrderUseCase from 'src/features/orders/domain/useCases/CreateOpenPayOrderUseCase';

export const ordersBindings = new ContainerModule((bind) => {
  // Services
  bind<OrdersServiceInterface>(OrdersService).to(OrdersService);
  bind<ComplaintsServiceInterface>(ComplaintsService).to(ComplaintsService);

  // Repositories
  bind<OrdersRepositoryInterface>(OrdersRepository).to(OrdersRepository);
  bind<ComplaintsRepositoryInterface>(ComplaintsRepository).to(
    ComplaintsRepository
  );

  // Use cases
  bind<CreateMercadopagoOrderUseCase>(CreateMercadopagoOrderUseCase).to(
    CreateMercadopagoOrderUseCase
  );
  bind<CreateBankTransferOrderUseCase>(CreateBankTransferOrderUseCase).to(
    CreateBankTransferOrderUseCase
  );
  bind<CreateEfektivaOrderUseCase>(CreateEfektivaOrderUseCase).to(
    CreateEfektivaOrderUseCase
  );
  bind<CreatePariTransferOrderUseCase>(CreatePariTransferOrderUseCase).to(
    CreatePariTransferOrderUseCase
  );
  bind<CreateMPWalletOrderUseCase>(CreateMPWalletOrderUseCase).to(
    CreateMPWalletOrderUseCase
  );
  bind<CreateClipOrderUseCase>(CreateClipOrderUseCase).to(
    CreateClipOrderUseCase
  );
  bind<CreateOpenPayOrderUseCase>(CreateOpenPayOrderUseCase).to(
    CreateOpenPayOrderUseCase
  );
});
